var map = {
	"./meta.js": 43,
	"./sparql/sparql.js": 96
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;


//////////////////
// WEBPACK FOOTER
// ./~/codemirror/mode ^\.\/.*\.js$
// module id = 95
// module chunks = 1